import { AlertTriangle } from "lucide-react";
import { fmtMoney, fmtNumber, fmtPercent } from "@/lib/format";

/**
 * Inline mismatch indicator shown next to a KPI that disagrees between the
 * Slack #daily-highlights post and the Sales Snapshot / Monthly Goals sheet.
 *
 * Per Joey's spec: when |delta| > 2%, the Slack value is treated as primary and
 * the sheet value is shown alongside it so the discrepancy can be investigated.
 */
function fmtBy(kind, v) {
  if (v == null) return "—";
  if (kind === "money") return fmtMoney(v);
  if (kind === "pct") return fmtPercent(v);
  return fmtNumber(v, 0);
}

export default function ReconcileFlag({ row, compact = false, testid }) {
  if (!row || !row.mismatch) return null;
  const kind = row.kind === "money" ? "money" : row.kind === "pct" ? "pct" : "int";

  if (compact) {
    return (
      <span
        className="inline-flex items-center gap-1 text-[10px] font-semibold text-yellow bg-navy px-1.5 py-0.5 rounded-sm tracking-wide"
        title={`Sheet ${fmtBy(kind, row.sheet)} · Slack ${fmtBy(kind, row.slack)}`}
        data-testid={testid || `reconcile-flag-${row.field}`}
      >
        <AlertTriangle className="w-3 h-3" />
        sheet mismatch
      </span>
    );
  }

  return (
    <div
      className="mt-1 inline-flex items-center gap-1 text-[10px] text-yellow bg-navy px-1.5 py-0.5 tracking-wide"
      data-testid={testid || `reconcile-flag-${row.field}`}
    >
      <AlertTriangle className="w-3 h-3" />
      <span className="font-semibold">sheet mismatch</span>
      <span className="opacity-90 ml-1">(sheet: {fmtBy(kind, row.sheet)} / Slack: {fmtBy(kind, row.slack)})</span>
    </div>
  );
}

/** Lookup helper to find a reconcile row by field name. */
export function findReconcile(reconcile, field) {
  if (!reconcile || !Array.isArray(reconcile.fields)) return null;
  return reconcile.fields.find((r) => r.field === field) || null;
}
